import React from 'react';

import { PlatformWidget } from '@/lib/module-federation';
import { FallbackPage404 } from './fallback';

const page404Fallback = {
  default: FallbackPage404,
  failed: FallbackPage404,
  isLoading: () => null
};

export const Page404 = () => {
  return <PlatformWidget domain="errors" placement="page-route" fallback={page404Fallback} />;
};
